function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#54585D",
  cx: "6",
  cy: "6",
  r: "6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.86 5.5a.5.5 0 01.09.992l-.09.008H3.07a.5.5 0 01-.09-.992l.09-.008H8.86z",
  fill: "#FFF"
}))));